// Email sending types
export interface EmailRecipient {
    email: string;
    name?: string;
}

export interface SendEmailPayload {
    to: string | EmailRecipient[];
    data: Record<string, unknown>;
    templateId: string;
    from?: EmailRecipient;
    subject?: string;
    cc?: string | EmailRecipient[];
    bcc?: string | EmailRecipient[];
}

export interface SendEmailResponse {
    success: boolean;
    messageId?: string;
    message?: string;
}

// Feedback conversation type (specific to mindy-app usage)
export interface FeedbackConversation {
    conversationId: string;
    userId: string;
    feedback: string;
    rating?: 'positive' | 'negative';
    timestamp?: string;
    userEmail?: string;
    userName?: string;
}
